import * as angular from 'angular';
import {
    applicationConfigurationModelFromDto,
    applicationConfigurationModelToDto
} from './application-configuration-form.functions';
import {
    loginServicesConfigurationModelFromDto,
    loginServicesConfigurationModelToDto
} from './login-services-form.functions';
import {
    registrationServicesConfigurationModelFromDto,
    registrationServicesConfigurationModelToDto
} from './registration-services-form.functions';

import {
    pushApprovalServicesConfigurationModelFromDto,
    pushApprovalServicesConfigurationModelToDto
} from './push-approval-services-form.functions';

export class Controller {

    /** @ngInject */
    constructor($rootScope, $state, Alert, ApplicationsResource, PhotoUploadService, ConfirmModal, $http) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
        this.PhotoUploadService = PhotoUploadService;
        this.ConfirmModal = ConfirmModal;
        this.$http = $http;
    }

    $onInit() {
        this.resetApplicationConfiguration();
        this.resetLoginServicesConfiguration();
        this.resetRegistrationServicesConfiguration();
        this.resetPushApprovalServicesConfiguration();

        let slug = this.application.applicationType.slug;


        let isOtherEPM = slug == 'enterprise-password-manager' && this.application.epmAppSettings.publicService.slug == 'other';

        this.customIconSupported = slug == 'custom' || slug == 'custom-saml' || slug == 'generic-oidc' || slug == 'generic-oauth2' || isOtherEPM;
        this.customLogoSupported = slug == 'custom-saml';

        

    }

    applicationConfigurationChanged($value, $invalid) {
        this.applicationConfiguration = $value;
        this.invalidApplicationConfiguration = $invalid;
    }

    applicationConfigurationIsNotModified() {
        return angular.equals(this.$applicationConfiguration, this.applicationConfiguration);
    }

    loginServicesConfigurationChanged($value, $invalid) {
        this.loginServicesConfiguration = $value;
        this.invalidLoginServicesConfiguration = $invalid;
    }

    loginServicesConfigurationIsNotModified() {
        return angular.equals(this.$loginServicesConfiguration, this.loginServicesConfiguration);
    }

    registrationServicesConfigurationChanged($value, $invalid) {
        this.registrationServicesConfiguration = $value;
        this.invalidRegistrationServicesConfiguration = $invalid;
    }

    registrationServicesConfigurationIsNotModified() {
        return angular.equals(this.$registrationServicesConfiguration, this.registrationServicesConfiguration);
    }

    pushApprovalServicesConfigurationChanged($value, $invalid) {
        this.pushApprovalServicesConfiguration = $value;
        this.invalidPushApprovalServicesConfiguration = $invalid;
    }

    pushApprovalServicesConfigurationIsNotModified() {
        return angular.equals(this.$pushApprovalServicesConfiguration, this.pushApprovalServicesConfiguration);
    }

    resetApplicationConfiguration() {
        this.$applicationConfiguration = applicationConfigurationModelFromDto(this.application);
        this.applicationConfiguration = applicationConfigurationModelFromDto(this.application);
    }

    resetLoginServicesConfiguration() {
        this.$loginServicesConfiguration = loginServicesConfigurationModelFromDto(this.application);
        this.loginServicesConfiguration = loginServicesConfigurationModelFromDto(this.application);
    }

    resetRegistrationServicesConfiguration() {
        this.$registrationServicesConfiguration = registrationServicesConfigurationModelFromDto(this.application);
        this.registrationServicesConfiguration = registrationServicesConfigurationModelFromDto(this.application);
    }

    resetPushApprovalServicesConfiguration() {
        this.$pushApprovalServicesConfiguration = pushApprovalServicesConfigurationModelFromDto(this.application);
        this.pushApprovalServicesConfiguration = pushApprovalServicesConfigurationModelFromDto(this.application);
    }

    save(dto) {
        this.isSaving = true;
        return this.ApplicationsResource
            .updateApplicationConfiguration(this.companyId, this.application.id, dto)
            .then(() => {
                this.Alert('success', 'company.manage-application.configuration.saved');
                Object.assign(this.application, dto);
                this.$onInit();
                this.$state.reload('company.manage-application');
            })
            .finally(() => this.isSaving = false)
    }

    saveIcon(iconFile) {
        return this.ApplicationsResource.uploadCustomIcon(this.companyId,this.application.id,iconFile,null)
            .then((data)=> {
                this.application.customIconUrl = data.customIcon;
                this.applicationConfiguration.customIconUrl = data.customIcon;
                this.Alert('success', 'saaspass_connect.updload_success');
        })
    }

    saveLogo(logoFile) {
        return this.ApplicationsResource.uploadCustomIcon(this.companyId,this.application.id,null,logoFile)
            .then((data)=> {
                this.application.customLogoUrl = data.customLogo;
                this.applicationConfiguration.customLogoUrl = data.customLogo;
                this.Alert('success', 'saaspass_connect.updload_success');
        })
    }

    resetIcon() {
        return this.ConfirmModal({
            messageKey:'Custom icon will be deleted and default icon will be used. Do you want to continue?',
            titleKey:'Confirm Delete'
        })
        .then(() =>
            this.ApplicationsResource.deleteCustomIcon(this.companyId,this.application.id)
                .then((data)=> {
                    this.application.customIconUrl = null;
                    this.applicationConfiguration.customIconUrl = null;
                    this.Alert('success', 'Custom icon is reset');
            })
        )
    }

    resetLogo() {
        return this.ConfirmModal({
            messageKey:'Custom logo will be deleted and default logo will be used. Do you want to continue?',
            titleKey:'Confirm Delete'
        })
        .then(() =>
            this.ApplicationsResource.deleteCustomLogo(this.companyId,this.application.id)
                .then((data)=> {
                    this.application.customLogoUrl = null;
                    this.applicationConfiguration.customLogoUrl = null;
                    this.Alert('success', 'Custom logo is reset');
            })
        )
    }

    saveApplicationConfiguration() {
        this.isSavingApplicationConfiguration = true;
        this.save({
            ...this.application,
            ...loginServicesConfigurationModelToDto(this.$loginServicesConfiguration),
            ...registrationServicesConfigurationModelToDto(this.$registrationServicesConfiguration),
            ...applicationConfigurationModelToDto(this.applicationConfiguration),
            ...pushApprovalServicesConfigurationModelToDto(this.$pushApprovalServicesConfiguration),
        }).finally(() => this.isSavingApplicationConfiguration = false)
    }

    changeApplicationStatus(saveAction) {
      if(saveAction){
        this.applicationConfiguration.isRunning = true;
        this.saveApplicationConfiguration();
      }else{
        const isRunning = this.application.status == 'RUNNING';
        const newStatus = !isRunning ? 'RUNNING' : 'PAUSED'
        return this.ApplicationsResource
            .changeApplicationStatus(
                this.companyId,
                this.application.id,
                newStatus
            )
            .then(() => {
                this.Alert('success', 'company.manage-application.configuration.saved');
                this.application.status = newStatus;
                this.$rootScope.$broadcast('breadcrumb-data-changed');
                this.$onInit();
            })
      }
    }

    saveLoginServicesConfiguration() {
        this.isSavingLoginServicesConfiguration = true;
        this.save({
            ...this.application,
            ...applicationConfigurationModelToDto(this.$applicationConfiguration),
            ...registrationServicesConfigurationModelToDto(this.$registrationServicesConfiguration),
            ...loginServicesConfigurationModelToDto(this.loginServicesConfiguration),
            ...pushApprovalServicesConfigurationModelToDto(this.$pushApprovalServicesConfiguration),
        }).finally(() => this.isSavingLoginServicesConfiguration = false)
    }

    saveMetadata(metadataUrl, metadataFile) {
        let ctrl = this;
        if (metadataUrl != null && metadataUrl.length > 0) {
            this.uploadMetadataUrl(metadataUrl);
        } else if (metadataFile != null) {
            var reader = new FileReader();
            reader.onload = function () {
                ctrl.uploadMetadataXml(reader.result);
            };
            if(metadataFile) {
                reader.readAsText(metadataFile);
            }
        }
    }

    uploadMetadataXml(metadataStr) {
        this.ApplicationsResource.uploadMetadataXml(this.companyId, this.application.id, this.application.configDTO, metadataStr)
            .then(()=> {
                this.Alert('success', 'company.manage-application.configuration.saved');
                this.$state.reload('company.manage-application');
        })
    }

    uploadMetadataUrl(metadataUrl) {
        this.ApplicationsResource.uploadMetadataUrl(this.companyId, this.application.id, this.application.configDTO, metadataUrl)
            .then(()=> {
                this.Alert('success', 'company.manage-application.configuration.saved');
                this.$state.reload('company.manage-application');
        })
    }

    saveName(applicationName) {
        return this.ApplicationsResource
            .updateApplicationConfiguration(
                this.companyId,
                this.application.id,
                {
                    ...this.application,
                    ...applicationConfigurationModelToDto(this.$applicationConfiguration),
                    ...loginServicesConfigurationModelToDto(this.$loginServicesConfiguration),
                    ...registrationServicesConfigurationModelToDto(this.$registrationServicesConfiguration),
                    ...pushApprovalServicesConfigurationModelToDto(this.$pushApprovalServicesConfiguration),
                    applicationName
                },
            )
            .then(() => {
                this.Alert('success', 'company.manage-application.configuration.saved-name');
                this.application.applicationName = applicationName;
                this.$rootScope.$broadcast('breadcrumb-data-changed');
                this.$onInit();
            })
    }

    saveRegistrationServicesConfiguration() {
        this.isSavingRegistrationServicesConfiguration = true;
        this.save({
            ...this.application,
            ...applicationConfigurationModelToDto(this.$applicationConfiguration),
            ...loginServicesConfigurationModelToDto(this.$loginServicesConfiguration),
            ...registrationServicesConfigurationModelToDto(this.registrationServicesConfiguration),
            ...pushApprovalServicesConfigurationModelToDto(this.$pushApprovalServicesConfiguration),
        }).finally(() => this.isSavingRegistrationServicesConfiguration = false)
    }

    savePushApprovalServicesConfiguration() {
        this.isSavingPushApprovalServicesConfiguration = true;
        this.save({
            ...this.application,
            ...applicationConfigurationModelToDto(this.$applicationConfiguration),
            ...loginServicesConfigurationModelToDto(this.$loginServicesConfiguration),
            ...registrationServicesConfigurationModelToDto(this.$registrationServicesConfiguration),
            ...pushApprovalServicesConfigurationModelToDto(this.pushApprovalServicesConfiguration),
        }).finally(() => this.isSavingPushApprovalServicesConfiguration = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/application-configuration.controller.js